import ChevronDown20 from '@carbon/icons-react/es/chevron--down/20';
import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Caption01, ProductiveHeading05 } from 'components/styles';

const Wrapper = styled.div<{ noPointer?: boolean }>`
  display: flex;
  align-items: center;
  margin-top: var(--spacing-03);
  margin-bottom: var(--spacing-05);
  cursor: ${({ noPointer }) => (noPointer ? 'default' : 'pointer')};
`;

const Icon = styled.div`
  height: 32px;
  margin-right: var(--spacing-04);
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: var(--spacing-06);
`;
const Label = styled.span`
  ${ProductiveHeading05};
  color: #000;
`;
const Description = styled.span`
  ${Caption01};
  color: var(--gray-80);
`;
const DropdownIcon = styled.div<{ hasDescription }>`
  height: 26px;
  ${ifProp(
    'hasDescription',
    css`
      align-self: flex-start;
    `,
  )};
`;

export const TitleSelectTrigger: FC<{
  icon?: ReactNode;
  label: ReactNode | string;
  description?: ReactNode | string;
}> = ({ icon, label, description }) => (
  <Wrapper>
    {icon != null ? <Icon>{icon}</Icon> : null}
    <NameWrapper>
      <Label>{label}</Label>
      {description != null ? <Description>{description}</Description> : null}
    </NameWrapper>

    <DropdownIcon hasDescription={description != null}>
      <ChevronDown20 />
    </DropdownIcon>
  </Wrapper>
);

export const UserTitleDisplay: FC<{
  icon?: ReactNode;
  label: ReactNode | string;
  description?: ReactNode | string;
}> = ({ icon, label, description }) => (
  <Wrapper noPointer>
    {icon != null ? <Icon>{icon}</Icon> : null}
    <NameWrapper>
      <Label>{label}</Label>
      {description != null ? <Description>{description}</Description> : null}
    </NameWrapper>
  </Wrapper>
);
